class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.button = this.querySelector('button[type="submit"]');
    this.init();
  }

  init() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.querySelectorAll('.badge .close-icon').forEach((closeIcon) => {
      closeIcon.addEventListener('click', this.handleRemoveDiscount.bind(this));
    });
  }

  async handleSubmit(e) {
    e.preventDefault();
    const inputs = this.querySelectorAll("input[name='discount']");
    const values = Array.from(inputs).map((input) => input.value);
    await this.updateCart(values.join(","));
  }

  handleRemoveDiscount(e) {
    e.preventDefault();
    const inputs = this.querySelectorAll("input[name='discount']");
    const values = Array.from(inputs).map((input) => input.value);
    const code = e.target.closest('.cart-drawer__discount-item').querySelector('input[name="discount"]').value;
    const discountCode = values.filter((value) => value !== code).filter(Boolean);
    this.updateCart(discountCode.join(","));
  }

  async updateCart(discountCode) {
    const formData = new FormData();
    formData.append("discount", discountCode);

    const cart = await (await fetch("/cart/update.js", {
      method: "POST",
      body: formData,
    })).json();

    const errorCard = cart.discount_codes.find((code) => code.applicable === false);
    if (errorCard) {
      this.handleError(errorCard);
    } else {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }

    this.button.setAttribute('aria-busy', false);
  }

  handleError(errorCard) {
    const errorMessage = this.querySelector("[data-error-message]");
    const baseMessage = errorMessage.dataset.errorMessage;
    errorMessage.removeAttribute("hidden");
    errorMessage.textContent = baseMessage.replace("\"\"", `"${errorCard.code}"`);
    this.querySelector('input[type="text"]').value = '';
  }
}

if (!window.customElements.get('cart-discount')) {
  window.customElements.define('cart-discount', CartDiscount);
}